import React, { type ComponentType } from 'react';
import type { popupNames } from 'reactApp/modules/popup/popup.types';
import { type Props as PopupProps, Popup } from 'reactApp/ui/Popup/Popup';

export function getPopupProps<P>({ name, component }: { name: keyof typeof popupNames; component: ComponentType<P> }) {
    return {
        name,
        component,
        modal: (props: PopupProps) => <Popup {...props} name={name} />,
    };
}
